<nz-list nzItemLayout="horizontal">
    <nz-list-item style="cursor: pointer;" *ngFor="let mdu of modal?.data; let i = index">
        <nz-list-item-meta [nzAvatar]="customAvatar">
            <nz-list-item-meta-title (click)="handlePinClick(mdu, i)">
              <div>{{ mdu.address_line_2 | titlecase }}</div>
            </nz-list-item-meta-title>

            <nz-list-item-meta-description>
              {{ mdu.address_line_1 | titlecase }}  {{ mdu.address_city | titlecase }}, {{ mdu.address_state | uppercase }} {{ mdu.address_zip }}
            </nz-list-item-meta-description>
        </nz-list-item-meta>

        <ng-template #customAvatar>
            <div 
                [style.background-color]="mdu.color || '#888888'"
                style="width: 32px; height: 32px; border-radius: 50%;">
            </div>
        </ng-template>
        
    </nz-list-item>

    <button nz-button nzType="primary" (click)="addMdu()">Add MDU</button>
</nz-list>